module.exports = __webpack_public_path__ + "img/443eb5867f3709cfbcb123ef46e563eb.svg";